import styled from 'styled-components';
import type { FunctionComponent } from 'react';
import { paletteHelper, Stack, Text, typographyHelper } from '@property.com.au/ui-kit';

interface SchoolTitle {
  part1: string;
  part2: string;
}

const Part1 = styled(Text).attrs(() => ({
  forwardedAs: 'span',
  variant: 'title01',
}))`
  line-height: 100%;
`;
const Part2 = styled(Text).attrs(() => ({
  forwardedAs: 'span',
}))`
  line-height: 100%;
  ${typographyHelper('title03Light')}
  color: ${paletteHelper('textSecondary')};
`;

export const SchoolTitle: FunctionComponent<SchoolTitle> = ({ part1, part2 }) => {
  return (
    <Stack as="p" gap="extraSmall">
      <Part1>{part1}</Part1> <Part2>{part2}</Part2>
    </Stack>
  );
};
